<template>
  <teleport to="body">
    <div v-if="ui.toast" class="ps-toast" :class="ui.toastType">{{ ui.toast }}</div>
  </teleport>
</template>

<script setup>
import { useUiStore } from '@/stores/ui'

const ui = useUiStore()
</script>

<style scoped>
.ps-toast {
  position: fixed;
  left: 50%;
  bottom: 32px;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}
.ps-toast.error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}
.ps-toast.success {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}
</style>
